// extracted by mini-css-extract-plugin
module.exports = {"base-space":"8px","photoOrganizer":"PhotoOrganizer_photoOrganizer__3RfJJ","title":"PhotoOrganizer_title__wmenz","icon":"PhotoOrganizer_icon__2rfsK"};